import { z } from "zod";

export const emptyResponseSchema = z.object({});
